// Single source for the `history:review` custom-tab spec — the three sites that
// open a review (a Proposals nav row, the `?view=diff`/non-author auto-open, and
// the author's "Review" button) all build it here, so the panelKind id + state
// shape live in one place. Pure (no React) — kept out of the view files.
import type { OpenTabSpec } from "@archlang/app-shell/workbench";

/** The changeset a review tab is opened for (the fields its state carries). */
export type ReviewTarget = Readonly<{
  id: string;
  number: number;
  title?: string | null;
}>;

/** The open-tab spec for a changeset's review (the `history:review` panelKind). */
export function reviewTabSpec(
  slug: string,
  repo: string,
  cs: ReviewTarget,
): OpenTabSpec {
  return {
    kind: "custom",
    pluginId: "history",
    panelKind: "history:review",
    state: {
      slug,
      repo,
      changesetId: cs.id,
      number: cs.number,
      title: cs.title ?? undefined,
    },
  };
}

/** Open a changeset's review as a plugin custom tab through a host opener
 *  (`ctx.openTab` in a contribution, `store.openTab` on the route). */
export function openReviewTab(
  openTab: (spec: OpenTabSpec) => void,
  slug: string,
  repo: string,
  cs: ReviewTarget,
): void {
  openTab(reviewTabSpec(slug, repo, cs));
}
